/**
 * Header Component for mobile navigation
 * Validates: Requirements 20.1 - Responsive design
 * Features glass morphism and red accent theme
 */

import { Icons } from '../icons';
import { THEME } from '../../styles/theme';

interface HeaderProps {
  onMenuClick: () => void;
  title?: string;
}

export function Header({ onMenuClick, title }: HeaderProps) {
  return (
    <header
      className="sticky top-0 z-30 border-b lg:hidden"
      style={{
        backgroundColor: 'rgba(5, 5, 5, 0.8)',
        backdropFilter: 'blur(20px)',
        borderColor: THEME.border,
      }}
    >
      <div className="flex items-center gap-4 px-4 py-3">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-lg transition-all duration-200 hover:bg-white/5"
          style={{ color: THEME.textSecondary }}
          aria-label="Open menu"
        >
          <Icons.Menu size={24} />
        </button>
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 rounded-xl flex items-center justify-center"
            style={{ background: THEME.accent }}
          >
            <Icons.Sparkles size={16} className="text-white" />
          </div>
          <span className="text-white font-semibold text-base">
            {title || 'Nexus AI'}
          </span>
        </div>
      </div>
    </header>
  );
}
